<div>
    <div>
        <div class="search-main">
            <div class="px-3 py-2 search-box">
                <!-- Search -->
                <div class="search-container">
                    <mat-icon class="text-icon search-icon">search</mat-icon>
                    <input type="text" [autocomplete]="'off'" class="form-control search-input w-100 h-100"
                        (input)="filterTemplate(searchField.value)" #searchField placeholder="Search by template name">
                </div>
            </div>
            @if(filteredTemplate){
            <div class="position-relative overflow-y-auto search-content">
                @if (filteredTemplate.length) {
                @for (
                template of filteredTemplate;
                track trackByFn(template);
                let i = $index
                ) {
                <div class="d-flex align-items-center title-container text-capitalize px-4 py-1">
                    <span>{{template.category}}</span>
                    @if(template.category === 'Favorites'){
                    <mat-icon class="start-icon">
                        star_border
                    </mat-icon>
                    }
                </div>
                @for (
                item of template.items;
                track trackTemplateByFn(item);
                let j = $index
                ) {
                <!-- Contact -->
                <button class="d-flex flex-column cursor-pointer align-items-start w-100 temp-btn px-4 py-1"
                    (click)="onTemplateSelection(item)" type="button">
                    <div class="d-flex temp-title ellipsis-desc">
                        <span class="ellipsis-desc">{{ item.name }}</span>
                        @if(data.defaultPreferredTemplate === item.identifier){
                        <span class="px-2 default-text ms-1">DEFAULT</span>
                        }
                    </div>
                    <div class="temp-desc ellipsis-desc" [matTooltip]="item.description">
                        {{item.description}}
                    </div>
                </button>
                }
                }
                }@else {
                <div class="p-4">
                    No search results found.
                </div>
                }
            </div>
            }
        </div>
    </div>
</div>